import { AuthGuard } from "@redotech/redo-customer-portal-app/contexts/auth";
import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import { Outlet, RouteObject } from "react-router-dom";
import { orderTrackingIframeRoutes } from "../order-tracking-iframes/routes";
import { giftReceiptRoutes } from "./gift-receipts/routes";
import { Page } from "./page";

const orderBreadcrumb = breadcrumbSlot();
const orderEditBreadcrumb = breadcrumbSlot();

export const orderRoutes: RouteObject[] = [
  // Temp custom order tracking iframe routes
  ...orderTrackingIframeRoutes,
  {
    handle: { breadcrumb: "Orders" },
    element: (
      <AuthGuard>
        <Outlet />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        path: "",
        lazy: async () => {
          const { Orders } = await import(
            "@redotech/redo-customer-portal-app/portal-four/orders/orders"
          );
          return {
            element: (
              <Page>
                <Orders registerOnly={false} />
              </Page>
            ),
          };
        },
      },
      {
        path: ":id",
        handle: { breadcrumb: orderBreadcrumb },
        lazy: async () => {
          const { Order } = await import("./order");
          return { element: <Order breadcrumb={orderBreadcrumb} /> };
        },
        children: [
          {
            path: "",
            lazy: async () => {
              const { OrderDetails } = await import("./order-details");
              return { Component: OrderDetails };
            },
            children: ["track", "track/:fulfillmentIndex"].map((path) => ({
              handle: { breadcrumb: "Tracking" },
              path,
              lazy: async () => {
                const { TrackingPageFulfillment } = await import(
                  "./order-tracking/fulfillment/tracking-page-fulfillment"
                );
                return { Component: TrackingPageFulfillment };
              },
            })),
          },
          {
            handle: { breadcrumb: orderEditBreadcrumb },
            path: "edit",
            lazy: async () => {
              const { OrderEdit } = await import("./order-edit");
              return {
                element: <OrderEdit breadcrumb={orderEditBreadcrumb} />,
              };
            },
          },
          {
            // TODO (JACK): This route should probably be limited to known return types and not just eat all possible routes
            path: ":returnType",
            lazy: async () => {
              const { Main } = await import(
                "@redotech/redo-customer-portal-app/portal-four/submission/main"
              );
              return { Component: Main };
            },
          },
          {
            path: "register",
            lazy: async () => {
              const { Main: RegistrationPortal } = await import(
                "@redotech/redo-customer-portal-app/portal-four/register/main"
              );
              return { element: <RegistrationPortal /> };
            },
          },
        ],
      },
      {
        path: "register",
        lazy: async () => {
          const { Orders } = await import(
            "@redotech/redo-customer-portal-app/portal-four/orders/index"
          );
          return {
            element: (
              <Page>
                <Orders registerOnly />
              </Page>
            ),
          };
        },
      },
      {
        path: ":id/gift-receipts",
        element: <Outlet />,
        children: giftReceiptRoutes,
      },
    ],
  },
];
